/**
 * Where an Online Policy stands with its wallets (the backend's `payment` record, shared/policyPaymentHold.js).
 * Older policies have no record: nothing is shown for them.
 */
const inr = (amount) =>
  `₹${(Math.round((Number(amount) || 0) * 100) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const paymentStateOf = (policy) => (policy && policy.payment && policy.payment.state) || "";

/** Saved ON HOLD at Create because a wallet was short: nothing charged yet, the automation waits for Remove hold. */
export const isWaitingForMoney = (policy) => ["WAITING_FOR_MONEY", "CHARGING"].includes(paymentStateOf(policy));

/** What Remove hold will charge, as one sentence ("Reliance Company Wallet ₹5,000.00 + the creator's Policy Wallet ₹5,000.00"). */
export const requiredText = (policy) => {
  const required = (policy && policy.payment && policy.payment.required) || {};
  const parts = (required.companies || []).map((c) => `${c.company} Company Wallet ${inr(c.amount)}`);
  if (Number(required.policyWallet) > 0) parts.push(`the creator's Policy Wallet ${inr(required.policyWallet)}`);
  return parts.join(" + ");
};

/** The chip / caption for a policy, or null for one without a payment record. */
export const paymentChipOf = (policy) => {
  const payment = policy && policy.payment;
  if (!payment || !payment.state) return null;
  switch (payment.state) {
    case "PAID": {
      const companies = (payment.charged && payment.charged.companies) || [];
      const total = companies.reduce((sum, c) => sum + (Number(c.amount) || 0), 0);
      return { label: total > 0 ? `Paid ${inr(total)}` : "Paid", tone: "success" };
    }
    case "NOT_NEEDED":
      return { label: "Payment link", tone: "default" };
    case "CHARGING":
      return { label: "Charging the wallet…", tone: "warning" };
    case "WAITING_FOR_MONEY":
      return { label: "Waiting for wallet money", tone: "error" };
    default:
      return null;
  }
};
